export const locale = {
  lang: 'en',
  data: {
    'HEADER': {
      'TITLE': 'List of accounting account',
      'NEW_CATEGORY': 'New category',
    },
  }
};
